import type { Modifier } from '@wix/patterns-dnd-kit-core';

export const restrictKeyboardToVerticalAxis: Modifier = ({
  activatorEvent,
  transform,
}) => {
  if (activatorEvent instanceof KeyboardEvent) {
    return { ...transform, x: 0 };
  }
  return transform;
};
